import React from 'react';
import { mergeClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import Section from '@app/ui/Section/Section';
import SpeakerCardItem from './SpeakerCardItem';
import SpeakerSlider from './SpeakerSlider/SpeakerSlider';
import { IAcademySpeakerApiModel } from '@app/models/features/course';
import SectionTitle from '@app/ui/Section/SectionTitle';

import styles from './SpeakerSection.module.scss';

export interface IProps {
    /**
     * Информация о спикерах
     */
    speakers: IAcademySpeakerApiModel[];
    /**
     * Название класса
     */
    className?: string;
    /**
     * Заголовок секции
     */
    title?: string | JSX.Element;
    /**
     * Заголовок секции (версия для мобильного разрешения)
     */
    mobileTitle?: string | JSX.Element;
}

/**
 * Компонент для отрисовки списка спикеров и экспертов
 */
const SpeakerSection:React.FC<IProps> = props => {
    const {
        speakers,
        className,
        title,
        mobileTitle,
    } = props;

    const containerClassName = mergeClassNames([
        styles['container'],
        className,
    ]);

    return (
        <Section
            className={containerClassName}
            animation={false}
            stretch="horizontally"
        >
            <div className={styles['slider-wrapper']}>
                <SectionTitle
                    tag="h2"
                    title={title ?? 'Спикеры и эксперты'}
                    mobileTitle={mobileTitle ?? 'Спикеры'}
                />
                <SpeakerSlider>
                    {speakers?.map(item => (
                        <SpeakerCardItem
                            key={item.name}
                            name={item.name}
                            position={item.position}
                            imageUrl={item.image_url}
                            imageAlt={item.image_alt}
                        />
                    ))}
                </SpeakerSlider>
            </div>
        </Section>
    );
};

export default SpeakerSection;